import { Text, View } from '@react-pdf/renderer';
import { globalStyles } from "config/pdfStyles";
import { useMemo } from "react";

// const styes = StyleSheet.create({
//   tableHead: {
//     width: 
//   }
// })

const GuardianDetailRowPdf = ({ data, styles, itemkey }) => {
  const details = useMemo(() => {
    if(!data?.selectedGuardians?.length) {
      return null;
    }
    return data.selectedGuardians.find(item => item.key === itemkey);
  }, [data?.selectedGuardians]);

  if(!details) {
    return null;
  }
  
  return (
    <>
      <View style={{ marginBottom: "10px" }}>
        <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px" }}>
          <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>{details?.key}</Text>
        </View>
        <View style={{ ...styles.flex, justifyContent: "space-between", marginBottom: 5 }}>
          <View style={{ gap: "3px", width: "20.5%" }}>
            <Text style={styles.subHeading}>LAST NAME</Text>
            <Text style={styles.para}>{details?.client_guardian?.lastname}</Text>
          </View>
          <View style={{ gap: "3px", width: "20.5%" }}>
            <Text style={styles.subHeading}>FIRST NAME</Text>
            <Text style={styles.para}>{details?.client_guardian?.firstname}</Text>
          </View>
          <View style={{ gap: "3px", width: "25%" }}>
            <Text style={styles.subHeading}>EMAIL</Text>
            <Text style={styles.para}>{details?.client_guardian?.email}</Text>
          </View>
          <View style={{ gap: "3px", width: "20%" }}>
            <Text style={styles.subHeading}>CITY/TOWN</Text>
            <Text style={styles.para}>{data?.schoolLocation}</Text>
          </View>
          <View style={{ gap: "3px", width: "20%" }}>
            <Text style={styles.subHeading}>SCHOOL</Text>
            <Text style={styles.para}>{data?.schoolName}</Text>
          </View>
        </View>
      </View>
    </>
  )
}

export default GuardianDetailRowPdf;